import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FileText,
  HardDrives as Server,
  House as Home,
  List as Menu,
  Shield
} from '@phosphor-icons/react';

const MobileBottomNav = ({ onMenuClick }) => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Dashboard', icon: Home },
    { path: '/agents', label: 'Agents', icon: Server },
    { path: '/vulnerabilities', label: 'Vulns', icon: Shield },
    { path: '/reports', label: 'Reports', icon: FileText },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-v4-bg/95 backdrop-blur-xl border-t border-white/[0.06] safe-area-bottom"
      aria-label="Navegación móvil"
    >
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              aria-current={active ? 'page' : undefined}
              className={`
                relative flex flex-col items-center justify-center flex-1 h-full
                transition-colors duration-200
                ${active
                  ? 'text-cyan-400'
                  : 'text-slate-500 active:text-slate-300'
                }
              `}
            >
              <Icon
                className={`h-5 w-5 transition-transform ${active ? 'scale-110' : ''}`}
                weight={active ? 'fill' : 'regular'}
                aria-hidden="true"
              />
              <span className="text-[10px] mt-1 font-medium tracking-wide">{item.label}</span>
              {active && (
                <span
                  aria-hidden="true"
                  className="absolute bottom-0 w-10 h-[2px] bg-cyan-400 rounded-full"
                />
              )}
            </Link>
          );
        })}

        {/* Menu button */}
        <button
          type="button"
          onClick={onMenuClick}
          aria-label="Abrir menú"
          className="flex flex-col items-center justify-center flex-1 h-full text-slate-500 active:text-slate-300 transition-colors"
        >
          <Menu className="h-5 w-5" weight="regular" aria-hidden="true" />
          <span className="text-[10px] mt-1 font-medium tracking-wide">More</span>
        </button>
      </div>

      {/* Safe area padding for iOS */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
};

export default MobileBottomNav;
